import React from 'react'
import { Redirect } from 'react-router'

import { ANSWER_SESSION_KEY } from 'pages/SuitabilityQuestion/SuitabilityQuestion'
import { WithFlowRouterProps } from 'utils/FlowProvider'
import { FlowRoute } from 'utils/FlowProvider/types'

import { enhance } from './enhance'
import { CheckingOnboardingWelcome } from './CheckingOnboarding'
import { EarlyOnboardingWelcome } from './EarlyOnboarding/index'

type InnerProps = WithFlowRouterProps

const Component: React.FC<InnerProps> = ({ flow }) => {
  // Clear any session storage to provide the same user experience going through onboarding
  window.sessionStorage.removeItem(ANSWER_SESSION_KEY)

  switch (flow) {
    case 'laterOnboarding':
      return <Redirect to={`${FlowRoute.LaterInterstitial}${window.location.search}`} />
    case 'investOnboarding':
      return <Redirect to={FlowRoute.InvestInterstitial} />
    case 'checkingOnboarding':
    case 'mocOnboarding':
      return <CheckingOnboardingWelcome />
    case 'earlyOnboarding':
      return <EarlyOnboardingWelcome />
    default:
      return <Redirect to={`/signup${window.location.search}`} />
  }
}

export const Welcome = enhance(Component)
